import { oz } from '@weft/utils';
import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { GET_HOME_PAGE_DATA_PATH } from './get-home-page-data-path';
import { GetHomePageDataResponseSchema } from './get-home-page-data-response-schema';

const TOP_GROSSING_CUSTOMER_SIZE_QUERY_PARAMETER = {
  name: 'topGrossingCustomersSize',
  location: 'query',
  schema: oz.number().int().min(1).max(100).optional().default(5),
} as const satisfies ZapiParam;

const TOP_GROSSING_PLAN_SIZE_QUERY_PARAMETER = {
  name: 'topGrossingPlansSize',
  location: 'query',
  schema: oz.number().int().min(1).max(100).optional().default(5),
} as const satisfies ZapiParam;

export const GET_HOME_PAGE_DATA_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-home-page-data',
  },
  queryParams: {
    [TOP_GROSSING_CUSTOMER_SIZE_QUERY_PARAMETER.name]: TOP_GROSSING_CUSTOMER_SIZE_QUERY_PARAMETER,
    [TOP_GROSSING_PLAN_SIZE_QUERY_PARAMETER.name]: TOP_GROSSING_PLAN_SIZE_QUERY_PARAMETER,
  },
  response: {
    name: 'GetHomePageDataResponse',
    schema: GetHomePageDataResponseSchema,
  },
  path: GET_HOME_PAGE_DATA_PATH,
} satisfies ZapiAction;

export type GetHomePageDataAction = typeof GET_HOME_PAGE_DATA_ACTION;